// extracted by mini-css-extract-plugin
export default {"wrapperTooltip":"Learn_wrapperTooltip__kUbS6","learn":"Learn_learn__djfQg","wrapperButton":"Learn_wrapperButton__IRYIM","wrapperLearn":"Learn_wrapperLearn__4SWOL"};